import { createAsyncThunk } from '@reduxjs/toolkit';

import { toggleTheme, setPrimaryColor } from '../reducers/themeReducer';

// Example of an async thunk action
export const initializeTheme = createAsyncThunk(
  'theme/initialize',
  async (_, { dispatch }) => {
    // Simulate fetching theme preferences from an API
    const response = await fetch('/api/theme-preferences');
    const preferences = await response.json();
    
    // Dispatch actions based on the fetched preferences
    dispatch(setPrimaryColor(preferences.primaryColor));
    if (preferences.mode === 'dark') {
      dispatch(toggleTheme());
    }
    
    return preferences;
  }
);

// Example of a regular action creator
export const updateThemePreferences = (preferences: { mode: 'light' | 'dark'; primaryColor: string }) => 
   async (dispatch: any) => {
    // Save preferences to API
    await fetch('/api/theme-preferences', {
      method: 'POST',
      body: JSON.stringify(preferences)
    });
    
    // Update local state
    dispatch(setPrimaryColor(preferences.primaryColor));
    if (preferences.mode === 'dark') {
      dispatch(toggleTheme());
    }
  };